import React from 'react';
import { Calendar, CalendarCheck, Hourglass, PoundSterling } from 'lucide-react';

const PAID = ['confirmed', 'completed'];

// At-a-glance booking metrics for the Bookings admin header.
export default function BookingsKpiStrip({ bookings }) {
  const now = new Date();
  const todayIso = new Date(now.getFullYear(), now.getMonth(), now.getDate()).toISOString().slice(0, 10);
  const weekStart = new Date(now); weekStart.setHours(0, 0, 0, 0); weekStart.setDate(now.getDate() - now.getDay());
  const weekEnd = new Date(weekStart); weekEnd.setDate(weekStart.getDate() + 7);

  const active = bookings.filter((b) => b.status !== 'cancelled');
  const todayCount = active.filter((b) => (b.date || '').slice(0, 10) === todayIso).length;
  const weekCount = active.filter((b) => {
    const iso = (b.date || '').slice(0, 10);
    if (!iso) return false;
    const d = new Date(iso + 'T00:00:00');
    return d >= weekStart && d < weekEnd;
  }).length;
  const pending = bookings.filter((b) => b.status === 'pending').length;
  const revenue = active.filter((b) => PAID.includes(b.status)).reduce((s, b) => s + (Number(b.total_price) || 0), 0);

  const tiles = [
    { label: 'TODAY', value: todayCount, icon: Calendar },
    { label: 'THIS WEEK', value: weekCount, icon: CalendarCheck },
    { label: 'PENDING', value: pending, icon: Hourglass },
    { label: 'BOOKING REVENUE', value: `£${revenue.toFixed(0)}`, icon: PoundSterling },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-6">
      {tiles.map((t) => (
        <div key={t.label} className="bg-[#111115] border border-white/5 p-4">
          <p className="text-white/30 text-[10px] font-bold tracking-widest mb-2 flex items-center gap-1.5">
            <t.icon className="w-3.5 h-3.5" /> {t.label}
          </p>
          <p className="text-white font-black text-xl">{t.value}</p>
        </div>
      ))}
    </div>
  );
}